import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { Breadcrumbs, BreadcrumbsService, GovBrBreadcrumbsModule } from '@serpro/ngx-dsgovbr';
import { Subscription } from 'rxjs';

@Component({
  selector: 'my-breadcrumb',
  templateUrl: './my-breadcrumb.component.html',
  styleUrl: './my-breadcrumb.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    GovBrBreadcrumbsModule
  ],
})
export class MyBreadcrumbComponent implements OnInit, OnDestroy, AfterViewInit {
  
  sub!: Subscription;
  maxItems: number = 2;
  breadcrumbs!: Breadcrumbs;

  // origin: string = window.location.origin;
  // href: string = window.location.href;
  // pathname: string = window.location.pathname;

  origin: string = this.obterUrlPortal();

  constructor(private breadcrumbsService: BreadcrumbsService) {}

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.queryBreadcrumbElements();
  }

  home(): string {
    return this.origin;
  }

  queryBreadcrumbElements(): void {
    this.origin = this.obterUrlPortal();
    setTimeout(() => {
      const globalFirstAnchor = document.querySelector('br-breadcrumbs li:first-child a');
      if (globalFirstAnchor) {
        globalFirstAnchor.setAttribute('href', this.origin);
        globalFirstAnchor.addEventListener('click', (event) => {
          event.preventDefault(); // previne a navegação padrão
          this.navigateToExternalPage(this.origin);
        });
      } else {
        // não encontrado
      }
    }, 500); // esperar a renderização do breadcrumb
  }

  navigateToExternalPage(url: string): void {
    window.location.href = url;
  }

  obterUrlPortal(): string {
    const fullUrl = window.location.href;
    const match = fullUrl.match(/^(https?:\/\/[^\/]+)/);
    return match ? match[1] : window.location.origin;
  }

  ngOnInit(): void {
    this.sub = this.breadcrumbsService
      .getBreadcrumbs()
      .subscribe((breadcrumbs) => {
        for (const breadcrumb of breadcrumbs) {
          breadcrumb.queryParams = undefined;
        }
        this.breadcrumbs = breadcrumbs;
        this.queryBreadcrumbElements();
      });
  }

}

